module.exports = __webpack_public_path__ + "img/模型.499f5f34.svg";